// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_6pPSsn","iconContainer":"_2HgrTh","iconContainerCompleted":"_2i455E","icon":"_7gNi0u","preTitle":"UjCKYz"};